import styled from 'styled-components'

export default styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .line-horizontal {
    width: 100%;
    height: 5px;
  }

  .line-vertical {
    width: 3px;
    min-height: 50%;
    height: 100%;
  }

`